export default __webpack_public_path__ + "static/media/Savior's Mantle of the Living Legend.38e6ba34.jpg";